import { toChunks } from "@utils/helpers";

import { AlgoliaTrackingService } from "@services/algolia/tracking/algoliaTracking.service";
import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import { ListImpressionTrackingInfo } from "@services/tracking/types/trackingInfo/listImpressionTrackingInfo";

import {
    AlgoliaAnalyticsEventNames,
    AlgoliaAnalyticsEvents,
} from "../AlgoliaAnalyticsEvents";
import {
    AlgoliaAnalyticsMinimumDataset,
    AlgoliaViewPayload,
} from "../AlgoliaAnalyticsMinimumDataset";

export interface AlgoliaAnalyticsContentListImpression
    extends AlgoliaAnalyticsMinimumDataset<AlgoliaViewPayload> {}

const getAlgoliaContentViewedPayload = (
    eventData: ListImpressionTrackingInfo,
    objectIDs: Array<string>,
): AlgoliaViewPayload => {
    return {
        authenticatedUserToken:
            AlgoliaTrackingService.getAuthenticatedUserToken(),
        eventName: AlgoliaAnalyticsEventNames.HitsViewed,
        index: eventData.meta.index,
        userToken: AlgoliaTrackingService.getUserToken(),
        objectIDs,
    };
};

const getAlgoliaAnalyticsContentListmpression = (
    data: TypedAnalyticsEvent<ListImpressionTrackingInfo>,
): Array<AlgoliaAnalyticsContentListImpression> => {
    const chunks = toChunks(data.payload.eventData.ids, 20);
    return chunks.map(chunk => ({
        eventName: AlgoliaAnalyticsEvents.ViewedObjectIDs,
        payload: getAlgoliaContentViewedPayload(data.payload.eventData, chunk),
    }));
};

export { getAlgoliaAnalyticsContentListmpression };
